import { useQuery } from "@tanstack/react-query";
import { cn } from "@/utils/cn";
import { fetchPreview } from "../packagesApi";
import AgentsToCreate from "./AgentsToCreate.jsx";
import GuideMode from "./GuideMode";
import PhonePreview from "./PhonePreview";
import QuestionsMode from "./QuestionsMode";

/**
 * Step 4: how the firm serves clients. Two ways in, same result: answer a few
 * questions, or hand us the firm's own roteiro. The phone on the side is the
 * same WhatsApp mockup the templates use, so the preview looks like what the
 * client sees; the firm can also talk to the agent there, and see which
 * agents will be created.
 */

function Tabs({ mode, onMode }) {
  const tab = (id, label) => (
    <button
      type="button"
      role="tab"
      aria-selected={mode === id}
      onClick={() => onMode(id)}
      className={cn(
        "min-h-[40px] rounded-full px-[18px] text-sm transition-colors",
        mode === id ? "bg-white font-semibold text-foreground shadow-[0_1px_2px_rgba(16,24,40,0.08)] dark:bg-white/15" : "font-medium text-muted-foreground",
      )}
    >
      {label}
    </button>
  );
  return (
    <div role="tablist" aria-label="Como configurar" className="flex rounded-full bg-black/[.06] p-1 dark:bg-white/[.06]">
      {tab("questions", "Responder perguntas")}
      {tab("guide", "Usar meu roteiro")}
    </div>
  );
}

export function ConfigureTabs(props) {
  return <Tabs {...props} />;
}

export default function StepConfigure({
  accountId,
  firmName,
  mode,
  baseSkill,
  baseValues,
  onBaseValues,
  onApply,
  applying,
  onAsk,
  guide,
  questionIndex,
  onQuestionIndex,
  tryAgent,
}) {
  const { data: conversation } = useQuery({
    queryKey: ["agent-skills", "preview", accountId, JSON.stringify(baseValues)],
    queryFn: () => fetchPreview(accountId, baseValues),
    enabled: Boolean(accountId),
    placeholderData: (previous) => previous,
    staleTime: 60_000,
  });

  return (
    <div className="flex flex-wrap items-start gap-8">
      <div className="flex min-w-0 flex-[999_1_540px] flex-col gap-4">
        {mode === "questions" ? (
          <QuestionsMode
            baseSkill={baseSkill}
            values={baseValues}
            onChange={onBaseValues}
            onFinish={() => onApply(null)}
            finishing={applying}
            onAsk={onAsk}
            index={questionIndex}
            onIndex={onQuestionIndex}
          />
        ) : (
          <GuideMode draft={guide.draft} onDraft={guide.onDraft} onBuild={guide.onBuild} error={guide.error} />
        )}
        <AgentsToCreate agents={tryAgent.agents} note={tryAgent.agentsNote} />
      </div>

      <PhonePreview
        key={mode}
        firmName={firmName}
        example={conversation || []}
        canTry={tryAgent.canTry}
        tryHint={tryAgent.hint}
        typingLabel={tryAgent.typingLabel}
        onReply={tryAgent.onReply}
      />
    </div>
  );
}
